import type { TFunction } from 'i18next';

import type { StationSensorAlertRuleRow } from '@/features/admin/types/opsExtended.types';

import type { IoTDataPoint } from '../types/realtime.types';

import { listThresholdBreachesForStation } from './applyAlertThresholdsToStations';

/** Mô tả chuông: mỗi trạm một dòng, bullet từng kênh vượt ngưỡng. */
export function formatIotThresholdVisitDescription(
  stations: IoTDataPoint[],
  thresholdRows: StationSensorAlertRuleRow[],
  t: TFunction,
): string {
  return stations
    .map((s) => {
      const name = (s.name ?? s.sensorId ?? s.id).trim() || s.id;
      const breaches = listThresholdBreachesForStation(s, thresholdRows);
      if (breaches.length === 0) {
        return name;
      }
      const parts = breaches.map((b) =>
        t('realtime.iotThresholdVisit.channelBreach', {
          channel: b.channelLabel,
          severity: t(`realtime.iotThresholdVisit.severity.${b.severity}`),
        }),
      );
      return `${name}: ${parts.join('; ')}`;
    })
    .join('\n');
}
